<app-pageheader Title="Price Sets">
  <add-button AddRoute="/settings/rates/ratesets/new/edit"></add-button>
</app-pageheader>


<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="parking/ratesets/searches"
  [AllowEdit]="true" [AllowDuplicate]="true"  EditUrl="/settings/rates/ratesets/:id/edit">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>